// extracted by mini-css-extract-plugin
export default {"actions":"Practices_actions__iachL"};